import type { MetricValues } from '../../PageConfigProvider/types/metric';
import { DataType, type TableData, type TimeseriesDataSet } from '../types';
import {
  getTableDimensionValue,
  getTableValue,
  groupTableRows,
} from './table-data';

export const tableToTimeseriesDataSet = (
  table: TableData,
  metric: MetricValues | undefined = table.metrics[0]
): TimeseriesDataSet | undefined => {
  const [dimension, secondaryDimension, ...otherDimensions] = table.dimensions;
  if (
    dimension === undefined ||
    dimension === 'timeseries' ||
    secondaryDimension !== 'timeseries' ||
    otherDimensions.length > 0 ||
    metric === undefined ||
    !table.metrics.includes(metric)
  ) {
    return undefined;
  }

  return {
    type: DataType.TIMESERIES,
    data: groupTableRows(table, dimension).map(({ value, rows }) => ({
      dim: value.label,
      timeseries: rows.map((row) => ({
        date: getTableDimensionValue(table, 'timeseries', row)?.id ?? '',
        value: getTableValue(table, metric, row),
      })),
    })),
  };
};
